
export default {
  name: 'RandomListPicker',
  data() {
    return {
      text: '',
      number: 1,
      randomedText: '',
    };
  },
  methods: {
    onRandomListPicker() {
      let lines = this.text.split('\n');

      lines = lines
        .map(line => line.trim()) // Trim each line
        .filter((line, index, self) => line && self.indexOf(line) === index); // Filter out empty lines and duplicates

      // Shuffle the array
      for (let i = lines.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [lines[i], lines[j]] = [lines[j], lines[i]];
      }

      // Pick a specified number of items
      this.randomedText = lines.slice(0, this.number).join('\n');
    },
    onSample() {
      this.text = "Apple\nBanana\nOrange\nApple\nGrape";
    },
    onReset() {
      this.text = '';
      this.randomedText = '';
    },
    copyToClipboard() {
      document.getElementById("text").select();
      document.execCommand('copy');
    }
  }
};

